<template>
	<div :class="setTabFixed ? 'fixed-top' : ''"  class="subtabs">
		<div id="learnViewTab" ref="learnViewTab" class="mdc-tab-bar main-tabs" role="tablist">
			<div class="mdc-tab-scroller " >
				<div class="mdc-tab-scroller__scroll-area">
					<div class="mdc-tab-scroller__scroll-content justify-content-center">
						<button class="mdc-tab mdc-tab--active" role="tab" tabindex="0" @click="changeTabType('ViewLesson')" @keypress="changeTabType('ViewLesson')" >
							<span class="mdc-tab__content">
								<span class="mdc-tab__text-label font-m t-body2">{{$t('139')}}</span>
							</span>
							<span class="mdc-tab-indicator mdc-tab-indicator--active">
								<span
									class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
							</span>
							<span class="mdc-tab__ripple"></span>
						</button>
						<button class="mdc-tab " role="tab" tabindex="0" @click="changeTabType('ViewExam')" @keypress="changeTabType('ViewExam')">
							<span class="mdc-tab__content">
								<span class="mdc-tab__text-label font-m t-body2">{{$t('140')}}</span>
							</span>
							<span class="mdc-tab-indicator ">
								<span
									class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
							</span>
							<span class="mdc-tab__ripple"></span>
						</button>
						<button class="mdc-tab" role="tab" tabindex="0" @click="changeTabType('ViewMission')" @keypress="changeTabType('ViewMission')">
							<span class="mdc-tab__content">
								<span class="mdc-tab__text-label font-m t-body2">{{$t('141')}}</span>
							</span>
							<span class="mdc-tab-indicator ">
								<span
									class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
							</span>
							<span class="mdc-tab__ripple"></span>
						</button>

						<button  class="mdc-tab" role="tab" tabindex="0" @click="changeTabType('ViewQuestion')" @keypress="changeTabType('ViewQuestion')">
							<span class="mdc-tab__content">
								<span class="mdc-tab__text-label font-m t-body2">{{$t('142')}}</span>
							</span>
							<span class="mdc-tab-indicator ">
								<span
									class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
							</span>
							<span class="mdc-tab__ripple"></span>
						</button>

						<button class="mdc-tab" role="tab" tabindex="0" @click="changeTabType('ViewSurvey')" @keypress="changeTabType('ViewSurvey')">
							<span class="mdc-tab__content">
								<span class="mdc-tab__text-label font-m t-body2">{{$t('1960')}}</span>
							</span>
							<span class="mdc-tab-indicator ">
								<span
									class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
							</span>
							<span class="mdc-tab__ripple"></span>
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="divider divider-subtabs"></div>
	</div>
</template>

<script>
/**
 * 나의 학습 상세 - 서브탭 컴포넌트(my learning view - sub tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'

export default {
    props: ['setTabFixed', 'tabType'],

    data() {
        return {
          learnViewTab: null,
          statusTab: null
        }
    },

    mounted() {
      this.statusTab = this.$route.query.status;
      // this.learnViewTab = new MDCTabBar(document.querySelector('#learnViewTab'))
	    // console.log(this.$route.query.tab);
	    // this.changeTabType(this.$route.query.tab)
	    this.changeTab(this.tabType);
	    
      // if(this.$route.query.tab) {
      //   if(this.$route.query.tab === 'ViewMission') {
      //     this.learnViewTab.activateTab(2);
      //   } else if(this.$route.query.tab === 'ViewQuestion') {
      //    this.learnViewTab.activateTab(3)
      //   } else {
      //     this.learnViewTab.activateTab(4)
      //   }
      //
      // }
    },

    updated() {
    
    },

    computed: {
       isTabType() {
           return this.tabType
       }
    },

    methods: {
        changeTabType(type) {
            // this.tabType = type;
            // this.$emit('setSubTab', type);
	        // if (type !== this.$route.query.tab) {
		        this.$router.replace({
			        name: 'LearnView',
			        params: {learnId: this.$route.params.learnId},
			        query: {
				        ...this.$route.query,
				        tab: type
			        }
		        });
	        // }
        },
	      changeTab(type) {
		      this.learnViewTab = new MDCTabBar(document.querySelector('#learnViewTab'))
		      if (type === 'ViewExam') {
			      this.learnViewTab.activateTab(1)
		      }else if (type === 'ViewMission') {
			      this.learnViewTab.activateTab(2)
		      }else if (type === 'ViewQuestion') {
			      this.learnViewTab.activateTab(3)
		      }else if (type === 'ViewSurvey') {
			      this.learnViewTab.activateTab(4)
		      }else {
			      this.learnViewTab.activateTab(0)
		      }
	      }
    }
}
</script>
